$(function () { 
    const faqQuestions = document.querySelectorAll('.js-faq-question');

    faqQuestions.forEach((question) => {
      question.addEventListener('click', () => {
        question.classList.toggle('_active');
      });
    });
})